@if (model) {
    <div
        ng-form="fieldRecordSubjectPlansForm"
        class="well">
        <h5 ng-bind="$ctrl.selectedPurpose.subjectPlanLabel">{{selectedPurpose.subjectPlanLabel}}</h5>
        @for (subjectPlan of model.subjectPlans; track subjectPlan; let i = $index) {
            <div class="row">
                <div class="col-xs-3">
                    <label
                        class="control-label"
                        [ngClass]="{'required-input': isSurveyTypeRequired()}"
                        ng-class="{'required-input': $ctrl.isSurveyTypeRequired()}"
                        >Plan type</label
                    >
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': isSurveyTypeRequired() && !isPlanTypeValid(i) && submitted}"
                        ng-class="{'has-error': fieldRecordSubjectPlansForm['planType' + $index].$invalid
                    && (fieldRecordSubjectPlansForm['planType' + $index].$dirty || fieldRecordSubjectPlansForm.$submitted)}">
                        <ng-select
                            class="nlr-ng-select"
                            #planType="ngModel"
                            [searchable]="false"
                            [clearable]="false"
                            name="planType"
                            id="planType"
                            placeholder="Select"
                            [items]="selectedPurposeSubjectPlanTypes"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="subjectPlan.planType"
                            (change)="updateSelectedPlanType($event, i)"
                            required>
                        </ng-select>
                    </div>
                </div>
                <div class="col-xs-3">
                    <label
                        class="control-label"
                        [ngClass]="{'required-input': subjectPlan.planType}"
                        ng-class="{'required-input': subjectPlan.planType}"
                        >Plan number</label
                    >
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': subjectPlan.planType && !planNumber.value && submitted}">
                        <span class="input-group-addon">
                            <i class="nlrp-icon nlrp-icon-edit"></i>
                        </span>
                        <input
                            #planNumber="ngModel"
                            type="number"
                            name="planNumber"
                            id="planNumber"
                            class="form-control"
                            [(ngModel)]="model.subjectPlans[i].planNumber"
                            (ngModelChange)="onPlanNumberChange($event, i)"
                            ng-disabled="!subjectPlan.planType"
                            [disabled]="!subjectPlan.planType"
                            required />
                    </div>
                </div>
                <div class="col-xs-6">
                    <label class="control-label">&nbsp;</label>
                    <div>
                        <i
                            class="nlrp-icon nlrp-icon-add-circle"
                            (click)="add(i)"
                            title="Add"
                            tabindex="0"></i>
                        <i
                            class="nlrp-icon nlrp-icon-remove-circle"
                            (click)="remove(i)"
                            title="Remove"
                            tabindex="0"></i>
                    </div>
                </div>
            </div>
        }
        @if (!hasMinSubjectPlans() && submitted) {
            <div class="row">
                <div class="col-xs-6">
                    <input
                        type="checkbox"
                        name="hasMinSubjectPlans"
                        class="hidden"
                        [(ngModel)]="model.hasMinSubjectPlans"
                        required />
                </div>
            </div>
        }
    </div>
}
